import { render, staticRenderFns } from "./CollegeStudent.vue?vue&type=template&id=2ffeae7e"
import script from "./CollegeStudent.vue?vue&type=script&lang=js"
export * from "./CollegeStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports